<template>
    <div
        class="md-map classic"
        :class="{ nbr: mapType === 'nbrInfo' && tabs && tabs.length }"
        v-if="show && lat && lng && !isHideSchoolMap"
        :style="{ marginBottom }"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div class="map-content" :style="contentStyle">
                <div
                    class="map-container"
                    :class="{
                        noscore: !(
                            listingWalkScore && listingWalkScore.walkscore > 0
                        )
                    }"
                    :style="containerStyle"
                >
                    <div
                        v-if="
                            listingWalkScore && listingWalkScore.walkscore > 0
                        "
                        class="work-score"
                        :class="{ 'hide-score': hideScore }"
                    >
                        <span class="score" :class="walkscoreClass">
                            {{ listingWalkScore.walkscore }}
                        </span>
                        <span class="label">
                            <span>{{ $t('md-map.walk') }}</span>
                            <br />
                            <span>{{ $t('md-map.score') }}</span>
                        </span>
                        <span v-if="listingWalkScore.description" class="info">
                            <span>{{ listingWalkScore.description }}</span>
                        </span>
                    </div>
                    <div v-if="replace" class="map-replace">
                        <iframe
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                            :src="`https://maps.google.com/maps?q=${lat},${lng}&z=${
                                parseInt(zoom) || 14
                            }&output=embed`"
                            :style="{
                                width: showGMap ? '100%' : '0%',
                                height: '100%'
                            }"
                            @load="replaceMapLoad = true"
                        ></iframe>
                    </div>
                    <component
                        :is="componentName"
                        v-else-if="canLoadMap && mapShow"
                        :zoom="zoom"
                        :mapConfig="mapConfig"
                        :tools="calTools"
                        :center="center"
                        :address="address"
                        :autoCenter="autoCenter"
                        :mapChangeEvent="mapChangeEvent"
                        :markerData="markerData"
                        :markerEventMap="markerEventMap"
                        @mapLoad="mapLoad"
                        @click="mapClick"
                    ></component>
                </div>
                <map-tab
                    v-if="mapType !== 'nbrInfo' && tabs && tabs.length"
                    :showCollapse="showCollapse"
                    v-model:replace="replace"
                    :tabs="tabs"
                    :selectTab="selectTab"
                    :houseLimit="houseLimit"
                    @updateMarkerEvent="updateMarkerEvent"
                    @updateMarkerData="updateMarkerData"
                    @doMapEvent="doMapEvent"
                    @updateMapClickEvent="updateMapClickEvent"
                ></map-tab>
                <map-tab-nbr
                    v-if="mapType === 'nbrInfo' && tabs && tabs.length"
                    :showCollapse="showCollapse"
                    v-model:replace="replace"
                    :tabs="tabs"
                    :selectTab="selectTab"
                    :houseLimit="houseLimit"
                    @showNormalMarker="showNormalMarker"
                    @updateMarkerEvent="updateMarkerEvent"
                    @updateMarkerData="updateMarkerData"
                    @doMapEvent="doMapEvent"
                    @updateMapClickEvent="updateMapClickEvent"
                ></map-tab-nbr>
            </div>
            <AttomDesc v-if="showDisclaimer" class="near-by-disclaimer" :content="$t('md-map.schoolDataProvided')" />
        </module-box>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';

import common from '../index';
import mapTab from './map-tab.vue';
import mapTabNbr from './map-tab-nbr.vue';
import { defineAsyncComponent } from 'vue';
export default {
    mixins: [common],
    computed: {

        ...rootMapState(usePageStore, {
            'page': store => store.page || {}
        }),
        calTools() {
            if (this.isMobileSize && this.mobileTools) {
                return this.mobileTools;
            } else {
                return this.tools;
            }
        },
        hideScore() {
            if (
                this.listingWalkScore &&
                !parseInt(this.listingWalkScore.walkscore)
            ) {
                return true;
            } else {
                return false;
            }
        },
        walkscoreClass() {
            let walkscoreClass = '';
            if (this.listingWalkScore) {
                const walkscore =
                    parseInt(this.listingWalkScore.walkscore) || 0;
                if (walkscore >= 80) {
                    walkscoreClass = 'high';
                } else if (walkscore >= 40) {
                    walkscoreClass = 'middle';
                } else {
                    walkscoreClass = 'low';
                }
            }
            return walkscoreClass;
        },
        
        componentName({ page }) {
            return page.map?.type === 'google' ? 'Map' : 'hereMap';
        },
    },
    mounted: function() {
        if (this.mapData?.type === 'city' || this.mapData?.type === 'neighborhood') {
            this.isShowNormalMarker = !this.selectTab;
            console.log('this.mapData', this.mapData)
            if (this.mapData?.type === 'neighborhood') {
                this.isShowNormalMarker = true
                this.mapData.zoom = 10
            }
            this.psMap.then(() => {
                const map = this.map;
                let oldZoom = Math.round(map.getZoom());
                this.markerEventMap = Object.assign({}, this.markerEventMap);
                this.mapChangeEvent = this.mapChangeEvent.concat([
                    () => {
                        const nowZoom = Math.round(map.getZoom());
                        if (nowZoom !== oldZoom) {
                            oldZoom = nowZoom;
                            this.showNormalMarker(this.isShowNormalMarker);
                        }
                    }
                ]);
                if (this.mapData?.type === 'neighborhood') {
                    this.showNormalMarker(this.isShowNormalMarker);
                } else if (this.mapData?.type === 'city' && !this.selectTab) {
                    this.getMarkerData().then(data => {
                        this.markerData = Object.assign({}, this.markerData, {
                            aggregation: data.aggregation || [],
                            // house: [],
                            city: data.city || []
                        });
                    })
                }
            });
        }
    },
    methods: {
        getMarkerData: function() {
            return this.psMap.then(() => {
                var zoom = Math.round(this.siteMap.map.getZoom());
                if (this.mapData?.type === 'city') {
                    return this.axiosIns
                        .get(
                            `/api-hj/hj-data/map/v3/city/${this.mapData.hjId}?zoom=${zoom}`
                        )
                        .then(res => res.data);
                } else if (this.mapData?.type === 'neighborhood') {
                    let url = this.mapData.url
                    if (url.indexOf('?') > -1) {
                        url += `&zoom=${zoom}`
                    } else {
                        url += `?zoom=${zoom}`
                    }
                    return this.axiosIns
                        .get(`${url}`)
                        .then(res => res.data?.markers || {});
                }
            });
        },
        showNormalMarker: function(isShow) {
            if (this.mapData?.type === 'city' ||
               (this.mapData?.type === 'neighborhood' && this.isCensusSubdivision)) {
                this.isShowNormalMarker = isShow;
                if (isShow) {
                    this.getMarkerData().then(data => {
                        this.markerData = Object.assign({}, this.markerData, {
                            aggregation: data.aggregation,
                            house: data.house,
                            city: data.city
                        });
                        if (this.mapData?.type === 'neighborhood' && data.boundary) {
                            this.siteMap.addBoundary(data.boundary);
                        }
                    });
                } else {
                    this.markerData = Object.assign({}, this.markerData, {
                        aggregation: [],
                        // house: [],
                        city: []
                    });
                }
            }
        }
    },
    components: {
        Map: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map_classic"*/ '@/components/map/classic.vue'
            )),
        hereMap: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map-here_classic"*/ '@/components/map-here/classic.vue'
            )),
        mapTab,
        mapTabNbr
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-map.classic {
    .map-content {
        position: relative;
        display: flex;
        height: 600px;
        border: 1px solid gainsboro;
        .map-container {
            flex-grow: 1;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            padding-top: 50px;
            .work-score {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                display: flex;
                align-items: center;
                height: 50px;
                background-color: #4e526c;
                padding: 0 15px;
                color: #fff;
                font-size: 15px;
                z-index: 1;
                &.hide-score {
                    .info {
                        display: none;
                    }
                }
                .score {
                    font-family: var(--font-bold);
                    font-size: 32px;
                    margin-right: 10px;
                    &.high {
                        color: #3ece77;
                    }

                    &.middle {
                        color: #ffb400;
                    }

                    &.low {
                        color: #ff5454;
                    }
                }
                .label {
                    font-size: 14px;
                    line-height: 12px;
                }
                .info {
                    font-size: 18px;
                    display: flex;
                    align-items: center;
                    span {
                        @include webkitBox(2);
                    }
                    &::before {
                        content: '|';
                        padding: 0 10px;
                        font-size: 18px;
                    }
                }
            }
            .map-replace {
                position: relative;
                width: 100%;
                height: 100%;
            }
            &.noscore {
                padding-top: 0;
            }
        }
        @include media-600 {
            height: auto;
            display: block;
            .map-container {
                width: 100%;
                height: 100vw;
            }
        }
    }
    .near-by-disclaimer {
        padding: 10px 0 0 0;
        color: var(--color-info);
        font-size: 12px;
        line-height: 16px;
        a.disclaimer {
            text-decoration: underline;
            @include color-theme();
        }
        @include media-600 {
            margin-top: 20px;
            border-top: 1px solid var(--color-border);
            padding: 10px 20px;
        }
    }
    .gm-style-pbc {
        z-index: 4 !important;
        pointer-events: none;
    }
}
</style>
